import {Component, OnInit} from "@angular/core"
import {AddNofeshService} from "../add-nofesh/add-nofesh.service"
import { INofesh } from "../../model/nofesh"
import { Router, ActivatedRoute, ParamMap } from '@angular/router';


@Component({
    templateUrl: './nofashim.component.html', 
    providers: [AddNofeshService]
})

export class NofashimComponent implements OnInit {
    
    constructor(private _nofeshService: AddNofeshService, private _route: Router){
        _nofeshService.getNofeshDdlData().subscribe(res => {}, error => {
            if (error.includes("401")) {
                localStorage.removeItem("token");
                location.reload();
            }
        })
        _nofeshService.getAllNofashim().subscribe( res => {this.nofashimList = res;} )
       
    }
    nofashimList: INofesh[];
    
    ngOnInit() {
        console.log('OnInit');
    }
    getNofeshDetails(nofesh_id:number){
        this._route.navigateByUrl('nofesh-admin/add-nofesh/' + nofesh_id);
    }
    addNofesh(){
        this._route.navigateByUrl('nofesh-admin/add-nofesh');
    }
    
    




}
